<h1 class="h3 mb-2 text-gray-800">Casos</h1>

<div class="card shadow mb-4">
    <div class="card-header py-3">
        <h6 class="m-0 font-weight-bold text-primary">Formulario de Casos</h6>
    </div>
    <div class="card-body">
        <div class="row">
            <div class="col-12">
                <form name="form" (ngSubmit)="f.form.valid && guardarDatos()" #f="ngForm">
                    <div class="row">
                        <div class="col-6">
                            <div class="form-group">
                                <label>Paciente</label>
                                <input type="text" class="form-control" name="paciente" [(ngModel)]="caso.paciente"
                                    #paciente="ngModel" [ngClass]="{'is-invalid':  f.submitted && paciente.invalid}"
                                    required />
                                <div *ngIf="f.submitted && paciente.invalid" class="invalid-feedback">
                                    <div *ngIf="paciente.errors.required">El Paciente es requerido</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Género</label>
                                <select class="form-control" name="genero" [(ngModel)]="caso.genero">
                                    <option value="0">Femenino</option>
                                    <option value="1">Masculino</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label>Fecha de Nacimiento</label>
                                <div class="input-group">
                                    <input class="form-control" placeholder="aaaa-mm-dd" name="fechaNacimientoObject"
                                        #fechaNacimientoInput="ngModel" required
                                        [ngClass]="{ 'is-invalid': f.submitted && fechaNacimientoInput.invalid }"
                                        [readonly]="true" [(ngModel)]="fechaNacimientoObject" ngbDatepicker
                                        #d="ngbDatepicker">
                                    <div class="input-group-append">
                                        <button class="btn btn-outline-primary fa fa-calendar-alt" (click)="d.toggle()"
                                            type="button"></button>
                                    </div>
                                </div>
                                <div *ngIf="f.submitted && fechaNacimientoInput.invalid" class="invalid-feedback">
                                    <div *ngIf="fechaNacimientoInput.errors.required">La fecha de nacimiento es
                                        requerida</div>
                                </div>
                            </div>
                            <div class="form-group">
                                <label>Número de identificación</label>
                                <input type="number" class="form-control" name="ci" [(ngModel)]="caso.ci"
                                    #codigoPaciente="ngModel"
                                    [ngClass]="{ 'is-invalid': f.submitted && codigoPaciente.invalid }" required />
                                <div *ngIf="f.submitted && codigoPaciente.invalid" class="invalid-feedback">
                                    <div *ngIf="codigoPaciente.errors.required">El número de paciente es requerido</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 offset-4">
                            <div class="form-group">
                                <label>Foto superior</label>
                                <div *ngIf="urlFotoSuperior"><img [src]="urlFotoSuperior" height="200"></div>
                                <input type="file" accept=".jpg, .jpeg, .png" #fileuploadTop="ngModel" [(ngModel)]="fotoSuperior"
                                    name="fotoSuperior" (change)="seleccionaFotoSuperior($event)" class="form-control"
                                    required [ngClass]="{ 'is-invalid': f.submitted && fileuploadTop.invalid }" />
                                <div *ngIf="f.submitted && fileuploadTop.invalid" class="invalid-feedback">
                                    <div *ngIf="fileuploadTop.errors.required">La foto superior es requerida</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="form-group">
                                <label>Foto Lateral Der</label>
                                <div *ngIf="urlFotoDerecha"><img [src]="urlFotoDerecha" height="200"></div>
                                <input type="file" accept=".jpg, .jpeg, .png" #fileuploadRight="ngModel" [(ngModel)]="fotoDerecha"
                                    name="fotoDerecha" required
                                    [ngClass]="{ 'is-invalid': f.submitted && fileuploadRight.invalid }"
                                    (change)="seleccionarFotoDerecha($event)" class="form-control" />
                                <div *ngIf="f.submitted && fileuploadRight.invalid" class="invalid-feedback">
                                    <div *ngIf="fileuploadRight.errors.required">La foto lateral derecha es requerida
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label>Frente intraoral</label>
                                <div *ngIf="urlFrenteIntraoral"><img [src]="urlFrenteIntraoral" height="200"></div>
                                <input type="file" accept=".jpg, .jpeg, .png" [(ngModel)]="frenteIntraoral" #frenteIntraoralFU="ngModel" required
                                    [ngClass]="{ 'is-invalid': f.submitted && frenteIntraoralFU.invalid }"
                                    name="frenteIntraoral" (change)="seleccionaFrenteIntraoral($event)"
                                    class="form-control" />
                                <div *ngIf="f.submitted && frenteIntraoralFU.invalid" class="invalid-feedback">
                                    <div *ngIf="frenteIntraoralFU.errors.required">El frente intraoral es requerido
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label>Foto Lateral Izq</label>
                                <div *ngIf="urlFotoIzquierda"><img [src]="urlFotoIzquierda" height="200"></div>
                                <input type="file" accept=".jpg, .jpeg, .png" #fileuploadLeft="ngModel" [(ngModel)]="fotoIzquierda"
                                    name="fotoIzquierda" required
                                    [ngClass]="{ 'is-invalid': f.submitted && fileuploadLeft.invalid }"
                                    (change)="seleccionarFotoIzquierda($event)" class="form-control" />
                                <div *ngIf="f.submitted && fileuploadLeft.invalid" class="invalid-feedback">
                                    <div *ngIf="fileuploadLeft.errors.required">La foto izquierda es requerida</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4 offset-4">
                            <div class="form-group">
                                <label>Foto Inferior</label>
                                <div *ngIf="urlFotoInferior"><img [src]="urlFotoInferior" height="200"></div>
                                <input type="file" accept=".jpg, .jpeg, .png" #fileuploadBottom="ngModel" [(ngModel)]="fotoInferior"
                                    name="fotoInferior" required
                                    [ngClass]="{ 'is-invalid': f.submitted && fileuploadBottom.invalid }"
                                    (change)="seleccionarFotoInferior($event)" class="form-control" />
                                <div *ngIf="f.submitted && fileuploadBottom.invalid" class="invalid-feedback">
                                    <div *ngIf="fileuploadBottom.errors.required">La foto inferior es requerida
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-4">
                            <div class="form-group">
                                <label>Frente facial</label>
                                <div *ngIf="urlFrenteFacial"><img [src]="urlFrenteFacial" height="200"></div>
                                <input type="file" accept=".jpg, .jpeg, .png" accept=".jpg, .jpeg, .png" #frenteFacialFU="ngModel" [(ngModel)]="frenteFacial" required
                                    [ngClass]="{ 'is-invalid': f.submitted && frenteFacialFU.invalid }"
                                    name="frenteFacial" (change)="seleccionaFrenteFacial($event)"
                                    class="form-control" />
                                <div *ngIf="f.submitted && frenteFacialFU.invalid" class="invalid-feedback">
                                    <div *ngIf="frenteFacialFU.errors.required">El frente facial es requerido
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label>Frente Facial Sonrisa</label>
                                <div *ngIf="urlFrenteFacialSonrisa"><img [src]="urlFrenteFacialSonrisa" height="200">
                                </div>
                                <input type="file" accept=".jpg, .jpeg, .png" accept=".jpg, .jpeg, .png" #frenteFacialSonrisaFU="ngModel" [(ngModel)]="frenteFacialSonrisa"
                                    name="frenteFacialSonrisa" (change)="seleccionaFrenteFacialSonrisa($event)" required
                                    [ngClass]="{ 'is-invalid': f.submitted && frenteFacialSonrisaFU.invalid }"
                                    class="form-control" />
                                <div *ngIf="f.submitted && frenteFacialSonrisaFU.invalid" class="invalid-feedback">
                                    <div *ngIf="frenteFacialSonrisaFU.errors.required">El frente facial de sonrisa es
                                        requerido
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-4">
                            <div class="form-group">
                                <label>Perfil Facial</label>
                                <div *ngIf="urlPerfilFacial"><img [src]="urlPerfilFacial" height="200"></div>
                                <input type="file" accept=".jpg, .jpeg, .png" accept=".jpg, .jpeg, .png" #fotografiaPerfilFacialFU="ngModel"
                                    [(ngModel)]="fotografiaPerfilFacial" required
                                    [ngClass]="{ 'is-invalid': f.submitted && fotografiaPerfilFacialFU.invalid }"
                                    name="fotografiaPerfilFacial" (change)="seleccionaFotografiaPerfilFacial($event)"
                                    class="form-control" />
                                <div *ngIf="f.submitted && fotografiaPerfilFacialFU.invalid" class="invalid-feedback">
                                    <div *ngIf="fotografiaPerfilFacialFU.errors.required">El perfil facial es
                                        requerido
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <div class="form-group">
                                <button type="submit" class="btn btn-primary">Solicitar
                                    Aprobación</button>
                                <a [routerLink]="'/casos/'+caso.id+'/verpaciente'" class="btn btn-link">Volver</a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>